import React from 'react'

function Certifications() {
  return (
    <>
      <div className="history-heading">Certifications</div>
      <div className="cert-container">
        <img className="cert-dl1"></img>
        <img className="cert-UCV"></img>
        <img className="cert-cv"></img>
        <img className="cert-dl1"></img>
        <img className="cert-dl1"></img>
        <img className="cert-ml"></img>
      </div>
    </>
  );
}

export default Certifications